var render = function render(){var _vm=this,_c=_vm._self._c;return _c('th',_vm._g(_vm._b({},'th',_vm.props.thAttrs,false),_vm.props.thEvents),[_c('span',{staticClass:"VueTables__heading",attrs:{"title":_vm.props.title}},[_vm._v(" "+_vm._s(_vm.columnName)+" "),_c('custom-sort-control',{attrs:{"is-sortable":_vm.isSortable,"has-been-sorted":_vm.hasBeenSorted,"ascending":_vm.ascending}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }